import classNames from 'classnames';
import { Checkbox } from 'semantic-ui-react';
import If from '../../../If/If';
import * as React from 'react';
import Icon from '../../Icon/Icon';
import { isNotNullOrUndefined } from '../../../../../Util/TypeGuards';

export interface CollapseExpandProps {
	contentName: string;
	content: React.ReactNode;
	description?: React.ReactNode;
	open: boolean;
	setOpen: (value: boolean) => void;
	checked: boolean;
	onCheckedChange?: (checked: boolean) => void;
	disabled?: boolean;
	checkboxVisible?: boolean;
	basicView?: boolean;
}

export function CollapseExpand({
	contentName,
	content,
	description,
	open,
	setOpen,
	checked,
	onCheckedChange,
	disabled = false,
	checkboxVisible = true,
	basicView = false,
}: CollapseExpandProps) {
	const handleCheckboxChange = (event: React.FormEvent<HTMLInputElement>, data: any) => {
		// Stop propagation to prevent header click from firing
		event.stopPropagation();

		const isChecked = data.checked;

		// If checking the box, also expand the section
		if (isChecked && !open) {
			setOpen(true);
		}

		// Call the parent's change handler
		onCheckedChange?.(isChecked);
	};

	const handleHeaderClick = (event: React.MouseEvent) => {
		// Don't toggle if clicking on the checkbox area
		const target = event.target as HTMLElement;
		if (target.closest('.ui.checkbox')) {
			return;
		}

		setOpen(!open);
	};

	return (
		<div className={classNames('collapse-expand__container', { selected: checked }, { 'basic-view': basicView })}>
			<div
				className={`collapse-expand__header ${contentName
					.toLowerCase()
					.replace(' / ', '-')
					.replace(' ', '-')}-field ${open ? 'open' : 'closed'} ${checked ? 'checked' : ''}`}
				onClick={handleHeaderClick}
				role="button"
				tabIndex={0}
				onKeyDown={e => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						setOpen(!open);
					}
				}}
			>
				<div className="collapse-expand__check-box">
					{checkboxVisible && !basicView && (
						<Checkbox
							checked={checked}
							onChange={handleCheckboxChange}
							disabled={disabled}
							onClick={e => e.stopPropagation()} // Prevent header click
						/>
					)}
					<p>{contentName}</p>
				</div>
				<Icon
					name={open ? 'chevron-up' : 'chevron-down'}
					classname={`chevron ${open ? 'chevron-up' : 'chevron-down'}`}
				/>
			</div>
			<If condition={open}>
				<div className="collapse-expand__body">
					<If condition={isNotNullOrUndefined(description)}>
						<div className="collapse-expand__description">
							<Icon name="info" />
							{description}
						</div>
					</If>
					{content}
				</div>
			</If>
		</div>
	);
}
